import { useCallback, useEffect, useState } from 'react'

import { BankDetail, BankDetailProps } from 'app/dataTypes/account/bankDetails/BankDetailsTypes'
import { useBankDetails, useFetchBikDetails } from 'app/dataProviders/account/bankDetails/hooks'
import useCallbackRef from 'app/common/hooks/useCallbackRef'


const BIK_LENGTH = 9
const CORR_ACCOUNT_LENGTH = 20

type Options = {
  onModified?: (state: boolean) => void
}

export function useBankDetailsBikCheking({ onModified }: Options) {
  const [bankDetailsProps, setBankDetailsProps] = useState({} as BankDetailProps)
  const { bankDetails, updateBankDetails, loading } = useBankDetails()
  const { bikProps, checkBik, bikError, setBikError, loadingBikProps } = useFetchBikDetails()

  const onModifiedRef = useCallbackRef(onModified)

  const formStateHandler = useCallback((value: BankDetail) => {
    onModifiedRef.current?.(true)
    setBankDetailsProps(prev => ({ ...prev, ...value }))
  }, [onModifiedRef])

  const resetBankDetails = useCallback(() => {
    setBankDetailsProps(bankDetails)
    onModifiedRef.current?.(false)
  }, [bankDetails, onModifiedRef])

  const bikRequestAndValidate = useCallback(async (bik: string) => {
    if (bik.length !== BIK_LENGTH) {
      setBikError('Введите корректное значение БИК')
      return
    }
    await checkBik(bik)
  }, [checkBik, setBikError])

  useEffect(() => {
    setBankDetailsProps({ ...bankDetailsProps, ...bikProps })
  }, [bikProps]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!loading) {
      resetBankDetails()
    }
  }, [bankDetails]) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    bikRequestAndValidate,
    updateBankDetails,
    bankDetailsProps,
    bankDetailsLoading: loading,
    resetBankDetails,
    bikError,
    loadingBikProps,
    formStateHandler,
    corrAccountLength: CORR_ACCOUNT_LENGTH,
    bikLength: BIK_LENGTH,
  }
}
